module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("1jdRY"))).then(() => parcelRequire('1iHdE'));